// extracted by mini-css-extract-plugin
module.exports = {"buttonPristine":"SendReminderButton_buttonPristine__3GKnN","buttonDirty":"SendReminderButton_buttonDirty__1GKB5"};